// Override Settings
var bcSfFilterSettings = {
		general: {
				limit: 20
				/* Optional */
				// loadProductFirst: true,
		}
};

// Declare Templates
var bcSfFilterTemplate = {
		'soldOutClass': 'sold-out',
		'saleClass': 'on-sale',
		'soldOutLabelHtml': '<div>Sold Out</div>',
		'saleLabelHtml': '<div>On Sale</div>',
		'vendorHtml': '<div>{{itemVendorLabel}}</div>',

		// Grid Template
		'productGridItemHtml': '<li class="collection-products-grid"><div class="product-item"><div class="img-section">' +
								      '<a href="{{itemUrl}}">' +
								        '<div class="img-container">' +
								          //'<img src="{{itemThumbUrl}}" alt="">' +
								          '{{itemThumbs}}' +
								        '</div>' +
								        '<span class="onsale-label {{saleTagLabel}}"></span>' +
								     '</a>' +
								    '</div>' +

								    '<div class="details-section">' +
								      '<div class="prod-name">' +
								        '<a href="{{itemUrl}}">{{itemTitle}}</a>' +
								      '</div>' +
								      '<div class="brandnprice">' +
								        '<span class="brand-name">{{itemVendor}}</span>' +
								          '<span class="price-tag regular">' +
								            '<span class="price">{{itemPrice}}</span>' +
								                      '</span>' +
								      '</div>' +
								      '<div class="swatch-select">' +
								        '<span class="swatch-option">{{itemColors}}</span>' +
								      '</div>' +
								      '<div class="product-description product description product-item-description">{{itemshortDescription}}' +
								      '</div>' +
								'</div></div></li>',

		// Pagination Template
		'previousActiveHtml': '<li><a class="pl-prev" href="{{itemUrl}}">&larr;</a></li>',
		'previousDisabledHtml': '<li class="pl-prev disabled"><span>&larr;</span></li>',
		'nextActiveHtml': '<li><a class="pl-next" href="{{itemUrl}}">&rarr;</a></li>',
		'nextDisabledHtml': '<li class="pl-next disabled"><span>&rarr;</span></li>',
		'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
		'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
		'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
		'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
	
		// Sorting Template
		'sortingHtml': '<label class="label--hidden"> Sorting </label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
		/*** Prepare data ***/
		var images = data.images_info;
//   console.log(data)
		data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		// var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (getParam('variant') !== null && getParam('variant') != '') {
				var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
				if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
				for (var i = 0; i < data['variants'].length; i++) {
						if (data['variants'][i].available) {
								firstVariant = data['variants'][i];
								break;
						}
				}
		}


		// lowest price based on availability
		var $x_comp_price = [], 
			$x_price = [],
			$x_price_min = [], 
			$x_price_max = [];
		for (var i = 0; i < data['variants'].length; i++) {
			var current_variant = data['variants'][i];
			if (current_variant.available) {
				$x_comp_price.push(current_variant.compare_at_price/100);
				$x_price.push(current_variant.price/100);
			}
		}
		$x_price_max = (Math.max.apply(null,$x_comp_price)).toFixed(2);
		$x_price_min = (Math.min.apply(null,$x_price)).toFixed(2);
		//console.log($x_price_min);
		//console.log($x_price_max);
		var priceVaries = $x_price_min != $x_price_max; // Check a product has many prices
		//console.log(priceVaries);

		var productVariants = data.options_with_values;
		var productcolors = '';
		var colorCtr = 0;
// 		$.each(productVariants, function(i,e) {
// 			if (e.name == "color") {
// 				$.each(e.values, function(id,el) {
// 					colortitle  = el.title
// 					productcolor = colortitle.toLowerCase().replace(/ /g,'-');
// 					productcolors += '<div class="swatch-option image" option-label="'+ colortitle +'"';
// 					productcolors += 'option-type="2" data-swatch="color-'+productcolor+'"><span class="color-hover">'+ colortitle +'</span></div>';
//                   	colorCtr++;
// 				});
// 			}
// 		});
        $('#swatch-repo > div').each(function(i,e){
          if($(e).data('name') === data.title) {
            productcolors += `
                              <div 
                              class="swatch-option image" 
							  option-label="${$(e).find('.color-hover').text()}" 
                              option-type="2" 
							  data-swatch="color-${$(e).find('.color-hover').text().toLowerCase().replace(/ /g, '-')}" 
							  style="background-color: ${$(e).find('.color-hover').text().toLowerCase().replace(/ /g, '-')}; background-image: url(${$(e).data('sw-img')});"
                              >
							  <span class="color-hover">${$(e).find('.color-hover').text()}</span>
                              </div>
                            `
          }
        })
		/*** End Prepare data ***/
  
  		function convertToSlug(Text){
            return Text
                .toLowerCase()
                .replace(/ /g,'_')
                .replace(/[^\w-]+/g,'')
            	.replace(/-/g,'_')
                ;
        }

		// Get Template
		var itemHtml = bcSfFilterTemplate.productGridItemHtml;

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
		
  		var productItemThumb = '';
  		var colorThumbIndex = 0;
//   		console.log(data.images)
        for(var clrImg=0; clrImg <= colorCtr; clrImg++){
          if(colorThumbIndex == 0 || images.length > colorThumbIndex){
            var colorThumbURL = this.optimizeImage(images[colorThumbIndex]['src']);
            productItemThumb += '<img src="'+ colorThumbURL +'" alt="">';
          } else {
            productItemThumb += '<img src="'+ colorThumbURL +'" alt="">';
          }

          if(data.product_type != 'Accessories'){
          	colorThumbIndex += 5;
          } else {
            if(data.tags.indexOf("1pic") > -1){
              colorThumbIndex++;
            } else {
              colorThumbIndex+= 2;
            }
          }
          
        }
  		itemHtml = itemHtml.replace(/{{itemThumbs}}/g, productItemThumb);
  

		// Add Price
		var itemPriceHtml = '';
		if (data.title != '')  {
	          var pricemeta = (onSale) ? '<p class="grid-link__meta onsale">' : '<p class="grid-link__meta solo">';
				itemPriceHtml += pricemeta;
				if (onSale) {
					// YES = ONSALE.
					// DOES PRICE VARY?
					if (priceVaries) { //YES
						var productMinPrice = (data.compare_at_price_min > data.price_min) ? data.price_min : data.price_min;
						// itemPriceHtml += '<span class="product-sales-price grid-link__sale_price" title="Sale Price"><b>As low as</b><br>' + this.formatMoney(productMinPrice) + '</span> ';
						itemPriceHtml += '<span class="product-sales-price grid-link__sale_price" title="Sale Price"><b>As low as</b><br>₱' + $x_price_min + '</span> ';
						// itemPriceHtml += '<span class="product-standard-price" title="Regular Price"><b>Reg</b><br>' + this.formatMoney(data.price_max) + '</span>';
						itemPriceHtml += '<span class="product-standard-price" title="Regular Price"><b>Reg</b><br>₱' + $x_price_max + '</span>';
					} else { //NO
						// itemPriceHtml += '<span class="product-sales-price grid-link__sale_price" title="Sale Price"><b>As low as</b><br>' + this.formatMoney(data.price_min) + '</span> ';
						// itemPriceHtml += '<span class="product-sales-price grid-link__sale_price" title="Sale Price"><b>As low as</b><br>₱' + $x_price_min + '</span> ';
						// itemPriceHtml += '<span class="product-standard-price" title="Regular Price"><b>Reg</b><br>' + this.formatMoney(data.compare_at_price_max) + '</span>';
						// itemPriceHtml += '<span class="product-standard-price" title="Regular Price"><b>Reg</b><br>₱' + $x_price_max + '</span>';
						itemPriceHtml += '<span class="price" title="Regular Price">₱' + $x_price_max + '</span>';
					}
				} else {
					// NOT ON SALE
					if (priceVaries) {
						// itemPriceHtml += '<span class="product-sales-price grid-link__sale_price" title="Sale Price"><b>Now</b><br>' + this.formatMoney(data.price_min) + '</span>';
						itemPriceHtml += '<span class="product-sales-price grid-link__sale_price" title="Sale Price"><b>Now</b><br>₱' + $x_price_min + '</span>';
						// itemPriceHtml += '<span class="product-standard-price" title="Regular Price"><b>Reg</b><br>' + this.formatMoney(data.price_max) + '</span>';
						itemPriceHtml += '<span class="product-standard-price" title="Regular Price"><b>Reg</b><br>₱' + $x_price_max + '</span>';
						//itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
					} else {
						// itemPriceHtml += '<span class="price" title="Regular Price">' + this.formatMoney(data.price_max) + '</span>';
						itemPriceHtml += '<span class="price" title="Regular Price">₱' + $x_price_max + '</span>';
					}
                }
				itemPriceHtml += '</p>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  
  		// add sale tag
	  	if (onSale){
          itemHtml = itemHtml.replace(/{{saleTagLabel}}/g, 'onsale');
        } else {
          itemHtml = itemHtml.replace(/{{saleTagLabel}}/g, '');
        }

		// Add soldOut class
		var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	
		// Add onSale class
		var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
	
		// Add soldOut Label
		var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

		// Add onSale Label
		var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);
  
  		// Add short description
  		var itemTitleSlug = convertToSlug(data.title);
        if (window.product_short_desc !== undefined){
          var itemshortdesc = window.product_short_desc[itemTitleSlug];
          if (itemshortdesc !== null && itemshortdesc !== undefined) {
            var arr = itemshortdesc.split(',');
            var forReplacing = '';
            $(arr).each(function(i,e){
              forReplacing += '<p>' + e + '</p>';
            });
            itemHtml = itemHtml.replace(/{{itemshortDescription}}/g, forReplacing);
          } else {
            itemHtml = itemHtml.replace(/{{itemshortDescription}}/g, '');
          }
        } else {
          itemHtml = itemHtml.replace(/{{itemshortDescription}}/g, '');
        }


		// Add Vendor
		var itemVendorHtml = bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemColors}}/g, productcolors);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
//   		console.log(data)

        if (!soldOut){
          return itemHtml;
        } else {
          return '';
        }
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  console.log(data);
		// // Add Description
		// var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		// // Truncate by word
		// itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
		// // Truncate by character
		// itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
		// itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
		for (var k in data) {
				// Featured image
				if (data['images_info'] > 0) {
						data[k]['featured_image'] = data['images_info'][0];
				} else {
						data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
				}

				// Add Options
				var optionsArr = [];
				for (var i in data[k]['options_with_values']) {
						optionsArr.push(data[k]['options_with_values'][i]['name']);
				}
				data[k]['options'] = optionsArr;

				// Customize variants
				for (var i in data[k]['variants']) {
						var variantOptionArr = [];
						var count = 1;
						var variant = data[k]['variants'][i];
						// Add Options
						var variantOptions = variant['merged_options'];
						if (Array.isArray(variantOptions)) {
								for (var j = 0; j < variantOptions.length; j++) {
										var temp = variantOptions[j].split(':');
										data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
										data[k]['variants'][i]['option_' + temp[0]] = temp[1];
										variantOptionArr.push(temp[1]);
								}
								data[k]['variants'][i]['options'] = variantOptionArr;
						}
						data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
						data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
				}

				// Add Description
				data[k]['description'] = data[k]['body_html'];
		}
  		window.prodlistbuilt = true;
		return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
		if (this.getSettingValue('general.paginationType') == 'default') {
				// Get page info
				var currentPage = parseInt(this.queryParams.page);
				var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

				// If it has only one page, clear Pagination
				if (totalPage == 1) {
						jQ(this.selector.bottomPagination).html('');
						return false;
				}

				if (this.getSettingValue('general.paginationType') == 'default') {
						var paginationHtml = bcSfFilterTemplate.paginateHtml;

						// Build Previous
						var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
						previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
						paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

						// Build Next
						var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
						nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
						paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

						// Create page items array
						var beforeCurrentPageArr = [];
						for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
								beforeCurrentPageArr.unshift(iBefore);
						}
						if (currentPage - 4 > 0) {
								beforeCurrentPageArr.unshift('...');
						}
						if (currentPage - 4 >= 0) {
								beforeCurrentPageArr.unshift(1);
						}
						beforeCurrentPageArr.push(currentPage);

						var afterCurrentPageArr = [];
						for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
								afterCurrentPageArr.push(iAfter);
						}
						if (currentPage + 3 < totalPage) {
								afterCurrentPageArr.push('...');
						}
						if (currentPage + 3 <= totalPage) {
								afterCurrentPageArr.push(totalPage);
						}

						// Build page items
						var pageItemsHtml = '';
						var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
						for (var iPage = 0; iPage < pageArr.length; iPage++) {
								if (pageArr[iPage] == '...') {
										pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
								} else {
										pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
								}
								pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
								pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
						}
						paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

						jQ(this.selector.bottomPagination).html(paginationHtml);
				}
		}
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
		if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
				jQ(this.selector.topSorting).html('');

				var sortingArr = this.getSortingList();
				if (sortingArr) {
						// Build content 
						var sortingItemsHtml = '';
                  		//var excludelabels = ['best-selling','manual']
                        sortingArr = { "created-descending": "Newest", "best-selling":"Best Selling", "price-ascending":"Lowest Price", "title-ascending":"Product Name"};
						for (var k in sortingArr) {
                          //var io = excludelabels.indexOf(k); //io == indexOf
							sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
						}
						var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
						jQ(this.selector.topSorting).html(html);

						// Set current value
						jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
				}
		}
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
//   var sw = $('.bc-sf-filter-option-swatch'),
//       swl = sw.find('[data-id="pf_opt_color"]'),
//       pswl = $('.swatch-option.image'),
//       burl = bcsffilter.fileUrl;
//   var sr = $('#swatch-repo'),
//       so = sr.find('.swatch-opt');
  
//   pswl.each((i, me) => {
//     var $this = $(me),
//         img = $this.data('swatch'),
//         label = $this.attr('option-label'),
//         ftxt = 'files/?',
//         nurl = burl.slice(0, burl.indexOf(ftxt) + ftxt.length - 1);
// //     console.log(burl)
//     $this.css({'background-color': label, 'background-image': `url('${nurl}${img}.png')`})
//   })
};

window.productInsertCount = 0;
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
  var adbox = $('#adbox-image')
  window.adBoxImage = adbox.attr('src');
  window.adBoxImageMobile = adbox.data('mobile');
  window.adBoxText = adbox.data('text');
  window.adBoxUrl = adbox.data('url');
  
  if(window.adBoxImage !== undefined && window.productInsertCount == 0){
    //var markup = '<li class="collection-products-grid ad-box"><div><img class="desktop" src="https:'+ window.adBoxImage +'"><img class="mobile" src="https:'+ window.adBoxImageMobile +'"><div class="box-content"><p>'+ window.adBoxText +'</p><a href="' + window.adBoxUrl + '">SHOP NOW</a></div></div></li>'
    var markup = '<li class="collection-products-grid ad-box"><div><a href="'+ window.adBoxUrl +'"><img class="desktop" src="https:'+ window.adBoxImage +'"><img class="mobile" src="https:'+ window.adBoxImageMobile +'"></a></div></div></li>'
    $(markup).insertAfter($('#bc-sf-filter-products').children().eq(1));
    window.productInsertCount = 1
  } else {
    console.log('undefined');
  }
};



/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { 
  var self = this; 
  var metaContent = 'meta[content="noindex,nofollow"]'; 
  if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { 
    var m = document.createElement('meta'); 
    m.name = 'robots'; 
    m.content = 'noindex,nofollow'; 
    document.head.appendChild(m); 
  } 
}; 
BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { 
  var self = this; 
  if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { 
    return true; 
  } 
  return false; 
};
/* boost-end-2.4.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
